import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Erreur capturée :", error);
    console.error("Stack React :", errorInfo?.componentStack);
  }

  handleReload = () => {
    // Option simple : rechargement complet
    localStorage.setItem("page","setup");
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20, fontFamily: 'monospace', whiteSpace: 'pre-wrap' }}>
          <h2>Une erreur est survenue, merci de prendre en photo le texte et de l'envoyer à Emmanuel puis cliquer sur le bouton ci-dessous</h2>
          <p><strong>{this.state.error?.message}</strong></p>
          <pre>{this.state.error?.stack}</pre>

          <button onClick={this.handleReload} style={{ marginTop: 20, width: "auto" }}>
            Redémarrer l’application
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
